import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LanguageService } from '../../services/i18n/language';
import { PresentationCarouselComponent } from './presentation-carousel/presentation-carousel.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, PresentationCarouselComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {
  title = 'Bilload - Цифровая платформа управления международной торговлей';

  // Блок «Выберите, как вы работаете с платформой»
  platformUsageTitleText = 'Выберите, как вы работаете с платформой';

  cargoOwnerTitle = 'Грузовладелец';
  cargoOwnerSubtitle = 'Для импортеров и компаний';
  cargoOwnerButtonText = 'Я - грузовладелец';

  freightForwarderTitle = 'Экспедитор грузов';
  freightForwarderSubtitle = 'Для логистических компаний';
  freightForwarderButtonText = 'Я - экспедитор';

  customsBrokerTitle = 'Таможенный брокер';
  customsBrokerSubtitle = 'Для таможенных представителей';
  customsBrokerButtonText = 'Я - таможенный брокер';

  supplierTitle = 'Поставщик';
  supplierSubtitle = 'Для производителей и продавцов товара';
  supplierButtonText = 'Я - поставщик';

  private subscriptions = new Subscription();

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.updateTranslations();

    this.subscriptions.add(
      this.languageService.getTranslations().subscribe(() => {
        this.updateTranslations();
        this.cdr.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /** Перевод по ключу. Пока словарь не загружен, вместо сырого ключа возвращаем пустую строку. */
  t(key: string): string {
    const value = this.languageService.translate(key);
    return !value || value === key ? '' : value;
  }

  /** Ссылка на WhatsApp Bilload с готовым сообщением из переводов (кнопки тарифов). */
  whatsappLink(messageKey: string): string {
    return `https://wa.me/77078880054?text=${encodeURIComponent(this.t(messageKey))}`;
  }

  onCalculateButtonClick(): void {
    // Публичный калькулятор: доступен без авторизации
    this.router.navigate(['/calculations/new']);
  }

  private updateTranslations(): void {
    const tr = (key: string, fallback: string) => this.languageService.translate(key) || fallback;

    this.platformUsageTitleText = tr('home.platformUsage.title', this.platformUsageTitleText);

    this.cargoOwnerTitle = tr('home.cargoOwner.title', this.cargoOwnerTitle);
    this.cargoOwnerSubtitle = tr('home.cargoOwner.subtitle', this.cargoOwnerSubtitle);
    this.cargoOwnerButtonText = tr('home.cargoOwner.button', this.cargoOwnerButtonText);

    this.freightForwarderTitle = tr('home.freightForwarder.title', this.freightForwarderTitle);
    this.freightForwarderSubtitle = tr('home.freightForwarder.subtitle', this.freightForwarderSubtitle);
    this.freightForwarderButtonText = tr('home.freightForwarder.button', this.freightForwarderButtonText);

    this.customsBrokerTitle = tr('home.customsBroker.title', this.customsBrokerTitle);
    this.customsBrokerSubtitle = tr('home.customsBroker.subtitle', this.customsBrokerSubtitle);
    this.customsBrokerButtonText = tr('home.customsBroker.button', this.customsBrokerButtonText);

    this.supplierTitle = tr('home.supplier.title', this.supplierTitle);
    this.supplierSubtitle = tr('home.supplier.subtitle', this.supplierSubtitle);
    this.supplierButtonText = tr('home.supplier.button', this.supplierButtonText);
  }
}
